import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import {AppComponent} from '../app.component';
import { AlertService } from '../alertpopup/_alert';
export class FetchCommunityData {
  ID: string;
  Code: string;
  CompanyName: string;
  Logo: string;
  AllocateUser: string;
  AllocateCompany: string;
  AllocateDisk: string;
  AllocateSMS: string;
  AllocateEmail: string;
  AllocateUnPaidUser: string;
  ConsumedPaidUser: string;
  ConsumedUser: string;
  ConsumedCompany: string;
  ConsumedEmail: string;
  ConsumedSMS: string;
  PaymentStatus: string;
  ConsumedDisk: string;
}

export class UpdateCommunity {
  fileSize: string;
  fileBase = [];
  fileName: string;
  CommunityName: string;
}

@Component({
    selector: 'app-community-profile',
    templateUrl: './community-profile.component.html',
    styleUrls: ['./community-profile.component.css'],
    standalone: false
})
export class CommunityProfileComponent implements OnInit {
  AddCommunityEvent: FormGroup;
  CommunityCode: string;
  RightsID: string;
  url: string;
  pageurl: string;
  DownloadURL: string;
  fileurls = [];
  dtColumns = [];
  fileSize: string;
  fileName: string;
  AllocateUser: string;
  AllocateCompany: string;
  AllocateDisk: string;
  AllocateSMS: string;
  AllocateEmail: string;
  AllocateUnPaidUser: string;
  ConsumedPaidUser: string;
  ConsumedUser: string;
  ConsumedCompany: string;
  ConsumedEmail: string;
  ConsumedSMS: string;
  PaymentStatus: string;
  ConsumedDisk: string;
  Logo: string;
  options = {
    autoClose: true,
    keepAfterRouteChange: false
};
  loading: boolean = false;
  licenseData: FetchCommunityData | null;
  constructor(private router: Router, private http: HttpClient, private formBuilder: FormBuilder, protected alertService: AlertService ) {
    this.url = AppComponent.baseURL;
    this.DownloadURL = AppComponent.DownloadURL;
  }

  ngOnInit() {
    this.RightsID = localStorage.getItem('UserRight');
    this.AddCommunityEvent = this.formBuilder.group({
      CommunityName: [''], browseFiles: ['']  });
    this.FetchCommunityRecord();
  }
  onSelectFile(event) {
    this.fileurls = [];
    this.fileName = '';
    this.fileSize = '';
    if (event.target.files && event.target.files[0]) {
        var filesAmount = event.target.files.length;
        for (let i = 0; i < filesAmount; i++) {
          this.fileName += event.target.files[i].name + ',';
          this.fileSize += event.target.files[i].size + ',';
          let reader = new FileReader();
          reader.onload = ( event: any) => { this.fileurls.push(event.target.result); };
          reader.readAsDataURL(event.target.files[i]);
        }
    }
  }
  FetchCommunityRecord() {
    this.loading = true;
    this.http.get(this.url + 'CommunityDetail/FetchCommunityDetail')
    .subscribe( (data) =>   {
        this.loading = false;
        if (data == null) {  } else {
          this.licenseData = JSON.parse(data.toString())[0];
          const CommunityData: FetchCommunityData = JSON.parse(data.toString())[0];
          this.AddCommunityEvent.patchValue({
            CommunityName: CommunityData.CompanyName});
          this.CommunityCode = CommunityData.Code;
          this.AllocateUser = CommunityData.AllocateUser;
          this.AllocateCompany = CommunityData.AllocateCompany;
          this.AllocateDisk = CommunityData.AllocateDisk;
          this.ConsumedDisk = CommunityData.ConsumedDisk;
          this.AllocateSMS = CommunityData.AllocateSMS;
          this.AllocateEmail = CommunityData.AllocateEmail;
          this.AllocateUnPaidUser = CommunityData.AllocateUnPaidUser;
          this.ConsumedPaidUser = CommunityData.ConsumedPaidUser;
          this.ConsumedUser = CommunityData.ConsumedUser;
          this.ConsumedCompany = CommunityData.ConsumedCompany;
          this.ConsumedEmail = CommunityData.ConsumedEmail;
          this.ConsumedSMS = CommunityData.ConsumedSMS;
          this.PaymentStatus = CommunityData.PaymentStatus;
          // tslint:disable-next-line: max-line-length
          this.Logo = CommunityData.Logo.trim() == '' ? 'assets/resources/images/fsl.png' : this.DownloadURL +"Attachment/"+ this.CommunityCode + '/' + CommunityData.Logo;
          localStorage.setItem('Logo', CommunityData.Logo);
        }
       }
    );
  }
  onCommunitySubmit(commintyFormData) {
      let updateCommunity: UpdateCommunity = {
       fileSize: this.fileSize,
       fileBase: this.fileurls,
       fileName: this.fileName,
       CommunityName: commintyFormData.CommunityName
      };
      this.http.post(this.url + 'CommunityDetail/UpdateCommunity', updateCommunity) .subscribe( (data) => {
             if (data == null) {
               this.alertService.error('Not Submited', true);
             } else {
               this.alertService.success('Submitted', this.options);
               this.FetchCommunityRecord();
             }
            }
          );
  }
}
